import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'gen-processing',
  templateUrl: './processing.component.html',
  styleUrls: ['./processing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProcessingComponent implements OnInit {

  @Input()
  diagnosticOrder: any; // Get from store instead?

  readonly pcrRunTitle = 'PCR Run Info';
  readonly pcrRunFields =
    [{"value":'file.uploadedFile.name', 'cssClass': 'wordBreak'},
      {"value":'file.uploadedFile.size'},
      {"value":'file.uploadedFile.pcrDate'},
      {"value":'file.uploadedFile.publisher'},
      {"value":'file.uploadedFile.instrument'},
      {"value":'file.uploadedFile.software'}];

  readonly sampleTitle = 'Sample Information';
  readonly sampleFields = [
    { 'value': 'tissueType.display'},
    { 'value': 'location'},
    { 'value': 'tumorPercent', 'cssClass': 'percentageValue'},
    { 'value': 'additionalNotes'}];

  isProcessingError: boolean = false; // TODO: How do I get this?


  thermalWarning: boolean = false;
  readonly thermalWarningMessage = 'Deviation in PCR protocol is detected, please consider that this might lead to ' +
    'inaccurate results. Please consult the executing technician or the OncoSignal team.';
  readonly processingErrorMessage = 'OncoSignal was not able to complete the analysis due to a server failure.' +
    '\n\nPlease try again, or if the problem persists contact Philips OncoSignal support for further assistance.';

  constructor() {
  }

  ngOnInit() {
    this.thermalWarning = this.diagnosticOrder.file.uploadedFile.warning;
  }

  isProcessingFailed() {
    return this.diagnosticOrder.workflowRequest.revisions[0].status === 'Failed';
  }


}
